import React from 'react';
import CoalStockPriceChart from './CoalStockPriceChart';

interface CoalStockPriceChartWrapperProps {
  startDate: string;
  endDate: string;
  isFullscreen?: boolean;
}

export function CoalStockPriceChartWrapper({ startDate, endDate, isFullscreen = false }: CoalStockPriceChartWrapperProps) {
  return (
    <div className={`text-left h-full w-full flex flex-col ${isFullscreen ? 'p-4' : ''}`}>
      <CoalStockPriceChart 
        startDate={startDate}
        endDate={endDate}
        isFullscreen={isFullscreen}
      />
    </div>
  );
}
